import { render, staticRenderFns } from "./KpiTile.vue?vue&type=template&id=2125e473&scoped=true"
import script from "./KpiTile.vue?vue&type=script&lang=js"
export * from "./KpiTile.vue?vue&type=script&lang=js"
import style0 from "./KpiTile.vue?vue&type=style&index=0&id=2125e473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125e473",
  null
  
)

export default component.exports